import React, { Component } from 'react';
import Pagination from './pagination';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ResultsTable from './resultsTable';

class SearchResults extends Component {
    handlePageChange = page => {
        const { data, itemsCount } = this.props;
        const pagesCount = Math.ceil(itemsCount / data.pageSize);

        switch(page)
        {
            case 'First':
                page = 1;
                break;
            case 'Prev':
                if(data.currentPage > 1)
                    page = data.currentPage - 1;
                else
                    page = 1;
                break;
            case 'Next':
                if(data.currentPage < pagesCount)
                    page = data.currentPage + 1;
                else
                    page = pagesCount;
                break;
            case 'Last':
                page = pagesCount;
                break;
            default:
                break;
        }

        this.props.doPageChange(page);
    }

    render() {
        const { data, results, itemsCount, columns, usePageNumbers, keyColumn} = this.props;
        const pagesCount = Math.ceil(itemsCount / data.pageSize);

        let pagination;
        let showingMsg;
        if((itemsCount > 0 && itemsCount > data.pageSize)){
            pagination = <Pagination itemsCount={itemsCount} pageSize={data.pageSize} currentPage={data.currentPage} onPageChange={this.handlePageChange} pageNumbers={usePageNumbers} />
        }
        else if(itemsCount === 0){
            pagination = <span>No results with specified criteria found.</span>
        }
        if(pagesCount >= 1)
            showingMsg = <span><span>Showing page {data.currentPage} of {pagesCount}</span><span style={{marginLeft: 20}}>({itemsCount} items found).</span></span>

         return ( 
            <React.Fragment>
                <div style={{float:'left'}}>
                    <h5><FontAwesomeIcon icon="list" />&nbsp;Search Results</h5>
                </div>
                <div style={{float:'right'}}>
                    <Button variant="link" onClick={() => this.props.onRefineSearch()}><FontAwesomeIcon icon="search" />&nbsp;Refine Search</Button>                     
                </div>
                <div>
                    <ResultsTable 
                        columns={columns}
                        results={results} 
                        itemsCount={itemsCount}
                        keyColumn={keyColumn}
                        onShowDetail={this.handleShowDetail}
                    />
                    {pagination}
                    {showingMsg}
                </div>
          </React.Fragment>
         );
    }
}
 
export default SearchResults;